import { createAsyncThunk } from "@reduxjs/toolkit";
import * as FeedServiceApi from "apis/FeedServiceApi";
import { setRecommendedUsers } from "./recommendedUsers.slice";

export const fetchRecommendedUsers = createAsyncThunk(
  "recommendedUsers/fetchRecommendedUsers",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await FeedServiceApi.getUserRecommendations();
      const recommendedUsers = response.data;
      if (Array.isArray(recommendedUsers)) {
        dispatch(setRecommendedUsers(recommendedUsers));
      } else {
        rejectWithValue("Invalid donors response format");
      }
    } catch (error) {
      const err = error as { response?: { data?: { error?: string } } };
      rejectWithValue(
        err.response?.data?.error || "Failed to fetch recommended users"
      );
    }
  }
);
